import { render } from "./Index.vue?vue&type=template&id=51f0a807&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=51f0a807&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f0a807"]])

export default __exports__